import Popups from '@/component/popups';
import bgBtn from "@assets/web-v3-images/btn-nodata.png";
import iconClosePopup from "@assets/web-v3-images/icons/exits.png";
import imageBody from "@assets/web-v3-images/img-body-intro1.png";
import bgPopupIntro from "@assets/web-v3-images/popupIntro-img.png";
import _ from "lodash";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../../helper/const";
import { getDataAwardListMiniGame } from "../../../../../Redux/futures/mini-game/action";
import { curStateMiniGame } from "../../../../../Redux/selector";

export default function PopupIntro({ open, onCancel }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      dispatch(getDataAwardListMiniGame());
    }
  }, []);

  const dataAwardSpecial = useMemo(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return {};
    }
    return dataMiniGame.dataAwardListMini.find((item = {}) => +item.rank === 1);
  }, [dataMiniGame.dataAwardListMini]);

  if (_.includes(location.pathname, PATH.MINI_GAME)) {
    return null;
  }

  const handleToMinigame = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
    onCancel();
  };

  return (
    <Popups
      className="!bg-transparent !shadow-none !p-0 mx-auto !-mt-12"
      open={open}
      onClose={onCancel}
    >
      <div className="position-relative">
        <img
          src={iconClosePopup}
          alt=""
          className="w-12 sm:w-18 absolute top-30 sm:top-50 right-5"
          onClick={onCancel}
        />
        <img src={bgPopupIntro} alt="" className="w-[100%] sm:w-[80%] h-auto mx-auto" />
        <div className="absolute top-[30%] sm:top-70 flex flex-col justify-center items-center px-10">
          <div className='text-[rgba(133,74,14,1)] text-[17px] sm:text-[21px] font-medium'>{t("mini_game.pop_up_invite.title")}</div>
          <div className='text-[rgba(133,74,14,1)] text-[17px] sm:text-[21px] font-extrabold'>
            {dataMiniGame.dataAwardListMini ? dataAwardSpecial?.name : ""}
          </div>
          <div className='text-[rgba(133,74,14,1)] text-[17px] sm:text-[21px] font-medium'>{t("mini_game.pop_up_invite.special_prize_trailing")}</div>
          <div className="px-[5%] sm:px-20 flex flex-col justify-center items-center">
            <img src={imageBody} alt="" className="w-auto sm:w-[90%] sm:pt-5" />
            <div className="text-center px-[3%]">
              <div className='text-[rgba(133,74,14,1)] text-[13px] sm:text-[18px] italic font-medium'>{t("mini_game.pop_up_invite.can_login")}</div>
              <div className='text-[rgba(133,74,14,1)] text-[13px] sm:text-[18px] italic font-medium pb-3'>{t("mini_game.pop_up_invite.prize_limit")}</div>
            </div>
            <div className="relative inline-block cursor-pointer px-[5%]" onClick={handleToMinigame}>
              <img src={bgBtn} alt="" className="block w-full h-auto" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrapfont-extrabold text-[17px] sm:text-[21px] text-white">
                {t("event_thingyan.home_page.play_now")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popups>
  );
}

